var localforage = {exports: {}};

export { localforage as __module };
//# sourceMappingURL=localforage2.js.map
